import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

function isUsableSupabaseValue(value) {
  if (!value || typeof value !== 'string') return false;
  const cleaned = value.trim();
  if (!cleaned) return false;
  if (cleaned.includes('your-project-ref')) return false;
  if (cleaned.includes('your-public-anon-key')) return false;
  return true;
}

export const isSupabaseConfigured =
  isUsableSupabaseValue(supabaseUrl) && isUsableSupabaseValue(supabaseAnonKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl.trim(), supabaseAnonKey.trim(), {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    })
  : null;
